import clsx from 'clsx';
import { Badge, Button } from '@material-ui/core';
import { NotificationsNoneRounded } from '@material-ui/icons';

import { useMozartButton } from './hooks';

import makeClasses from './MozartButton.style';

export function MozartButton(props: Props) {
  const { onClick } = props;

  const { lang, animatePulse, animateLabel, unseenAlerts } = useMozartButton();

  const _classes = makeClasses();

  return (
    <Button
      onClick={onClick}
      classes={{
        root: clsx(_classes.btn, {
          hasUnseenAlerts: unseenAlerts.hasAlerts,
          pulsing: animatePulse,
        }),
      }}
    >
      <Badge
        max={99}
        color='error'
        classes={{ badge: _classes.badge }}
        badgeContent={animateLabel ? null : unseenAlerts.amount}
      >
        <NotificationsNoneRounded />
      </Badge>
      <div
        className={clsx(_classes.labelContainer, {
          expanded: animateLabel,
          compact: !animateLabel,
        })}
      >
        <p className={clsx(_classes.label, { show: animateLabel })}>
          {lang.label}
        </p>
      </div>
    </Button>
  );
}

interface Props {
  onClick: () => void;
}
